import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Switch from "@mui/material/Switch";
import styled from "styled-components";
import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

import { useSelector } from "react-redux";
import useAxios from "../../../../api/useAxios";
import { API_URL } from "../../../../api";

export default function BankInfoDialog(props) {
  const instance = useAxios();
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [bodyParts, setBodyParts] = useState("");

  const [description, setDescription] = useState("");
  const [bpData, setBpData] = useState([]);
  const [bookableTreatments, setBookableTreatments] = useState(false);
  const [errors, setErrors] = useState({
    code: "",
    name: "",
    bodyParts: "",
  });

  const TreatmentCreate = () => {

    const validate = () => {
      const newErrors = {};
      if (!code.trim()) newErrors.code = "Code is required";
      if (!name.trim()) newErrors.name = "Name is required";
      if (!bodyParts) newErrors.bodyParts = "Body Part is required";

      setErrors(newErrors);

      return Object.keys(newErrors).length === 0;
    };

    if (!validate()) return;

    const data = new FormData();
    data.append("name", name);
    data.append("code", code);
    data.append("bodyParts", bodyParts);
    data.append("description", description);
    data.append("isBookable", Boolean(bookableTreatments));

    const config = {
      headers: { "Content-Type": "multipart/form-data" },
    };
    api.post("treatment-list", data, config).then(function (response) {
      Swal.fire({
        title: "Successful!",
        text: "You Created Treatment Data!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
      });

      const selectedBodyPart = bpData.find(
        (item) => item._id === response?.data?.data?.bodyParts
      );
      const formattedData = {
        ...response.data?.data,
        bodyParts: selectedBodyPart || {},
      };

      props.setTreatmentLists((prev) => [...prev, formattedData]);
      // props.newTreatmentList(response.data?.data);

      // window.location.reload()
    });
    props.close();
  };

  useEffect(() => {
    const getBodyParts = async () => {
      try {
        const response = await instance.get("/ho/body-parts");
        setBpData(response.data.data);
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: "Something Went Wrong",
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      }
    };

    getBodyParts();
  }, []);

  const handleCode = (e) => {
    if (e.target.value.trim() !== "") {
      setErrors({
        ...errors,
        code: "",
      });
    }
    setCode(e.target.value);
  };

  const handleTreatmentName = (e) => {
    if (e.target.value.trim() !== "") {
      setErrors({
        ...errors,
        name: "",
      });
    }
    setName(e.target.value);
  };

  const handleBodyParts = (e) => {
    if (e.target.value.trim() !== "") {
      setErrors({
        ...errors,
        bodyParts: "",
      });
    }
    setBodyParts(e.target.value);
  };

  return (
    <div>
      <Dialog open={props.open} onClose={props.close} fullWidth maxWidth="md">
        <DialogTitle>
          {" "}
          <div className="modal-header bg-info">
            <h4 className="modal-title">Create Treatment</h4>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={props.close}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>

          <div class="modal-body">
            <div class="form-group">
              <label for="name">Code</label>
              <input
                type="text"
                class="form-control border border-info"
                name="code"
                onChange={handleCode}
              />
              {errors.code && <p style={{ color: "red" }}>{errors.code}</p>}
            </div>
            <div class="form-group">
              <label for="name">Name</label>
              <input
                type="text"
                class="form-control border border-info"
                name="name"
                placeholder="eg. mg mg"
                onChange={handleTreatmentName}
              />
              {errors.name && <p style={{ color: "red" }}>{errors.name}</p>}
            </div>
            <div class="form-group">
              <label for="name">Choose Body Parts</label>
              <select
                name="currency"
                id=""
                className="form-control mt-1"
                onchange="convert(this.value)"
                onChange={handleBodyParts}
              >
                <option hidden>Choose Body Parts</option>

                {bpData.map((bp) => (
                  <option value={bp._id}>{bp.name}</option>
                ))}
              </select>
              {errors.bodyParts && (
                <p style={{ color: "red" }}>{errors.bodyParts}</p>
              )}
            </div>
            <div class="form-group">
              <label for="name">Description</label>
              <textarea
                className="form-control"
                id="description"
                onChange={(e) => setDescription(e.target.value)}
              ></textarea>
            </div>
            <div className="form-group d-flex align-items-center mt-3">
              <label className="mb-0 mr-3">Bookable Treatments</label>
              <Switch
                checked={bookableTreatments}
                onChange={(e) => setBookableTreatments(e.target.checked)}
              />
            </div>
          </div>
          <div class="modal-footer">
            <Button
              class="btn btn-secondary"
              data-dismiss="modal"
              onClick={props.close}
            >
              Close
            </Button>
            <Button onClick={TreatmentCreate} class="btn btn-primary">
              Save
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
// phyo
//maymyat
